<template>
  <div class="bid-wrap">
    <div class="card-header">出价</div>
    <ul class="modal-form">
      <el-form :model="formData" :disabled="!!alreadyCampaignId" :rules="rules" ref="bidFormRef">
        <li class="form-item">
          <span class="form-label">您希望着重实现的目标是什么：</span>
          <el-form-item prop="geoName">
            <div class="form-value">
              <el-radio-group
                v-model="formData.optimizationGoal"
                size="mini"
                @change="changeOptimizationGoal"
              >
                <el-radio-button label="OPTIMIZE_INSTALLS_TARGET_INSTALL_COST"
                  >安装量</el-radio-button
                >
                <el-radio-button label="OPTIMIZE_IN_APP_CONVERSIONS_TARGET_CONVERSION_COST"
                  >应用内操作次数</el-radio-button
                >
                <el-radio-button label="OPTIMIZE_RETURN_ON_ADVERTISING_SPEND"
                  >应用内操作价值</el-radio-button
                >
              </el-radio-group>
            </div>
          </el-form-item>
        </li>
        <li class="form-item">
          <span
            class="form-label"
            :class="{
              require: formData.optimizationGoal !== 'OPTIMIZE_INSTALLS_TARGET_INSTALL_COST',
            }"
            >您希望如何跟踪安装次数：</span
          >
          <el-form-item prop="trackInstallVolumeAction">
            <div class="form-value">
              <el-select
                clearable
                v-model="formData.trackInstallVolumeAction.conversionId"
                style="width: 500px"
                filterable
                placeholder="请选择跟踪安装次数"
              >
                <el-option
                  v-for="item in installNumList"
                  :key="item.conversionId"
                  :label="item.conversionName"
                  :value="item.conversionId"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
        </li>
        <li
          class="form-item"
          v-show="formData.optimizationGoal === 'OPTIMIZE_INSTALLS_TARGET_INSTALL_COST'"
        >
          <span class="form-label require">您希望定位哪类用户：</span>
          <el-form-item prop="targetUser">
            <div class="form-value">
              <el-select
                @change="changeTargetUser"
                clearable
                v-model="formData.targetUser"
                style="width: 500px"
                filterable
                placeholder="请选择定位用户类型"
              >
                <el-option
                  v-for="item in targetUserList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
        </li>
        <li
          class="form-item"
          v-show="
            formData.optimizationGoal !== 'OPTIMIZE_INSTALLS_TARGET_INSTALL_COST' ||
            (formData.optimizationGoal === 'OPTIMIZE_INSTALLS_TARGET_INSTALL_COST' &&
              formData.targetUser === 'IN-APP_ACTIONS')
          "
        >
          <span class="form-label require">哪些转化操作对您最为重要：</span>
          <el-form-item prop="conversionActions">
            <div class="form-value">
              <el-select
                clearable
                v-model="formData.conversionActions.conversionId"
                multiple
                collapse-tags
                style="width: 500px"
                filterable
                placeholder="请选择转化操作"
              >
                <el-option
                  v-for="item in translateOperoteList"
                  :key="item.conversionId"
                  :label="item.conversionName"
                  :value="item.conversionId"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
        </li>
        <li class="form-item">
          <span class="form-label require">日预算：</span>
          <el-form-item prop="dailyBudget">
            <div class="form-value">
              <el-input
                style="width: 264px"
                v-model.trim="formData.dailyBudget"
                placeholder="请输入日预算"
              >
                <template slot="append">USD</template>
              </el-input>
            </div>
          </el-form-item>
        </li>
        <li
          class="form-item"
          v-if="formData.optimizationGoal === 'OPTIMIZE_RETURN_ON_ADVERTISING_SPEND'"
        >
          <span class="form-label require">tROAS%：</span>
          <el-form-item prop="roas">
            <div class="form-value">
              <el-input
                style="width: 264px"
                v-model.trim="formData.roas"
                placeholder="请输入tROAS%"
              >
                <template slot="append">%</template>
              </el-input>
            </div>
          </el-form-item>
        </li>
        <li class="form-item" v-else>
          <span class="form-label require">出价：</span>
          <el-form-item prop="cpa">
            <div
              class="form-value"
              v-if="formData.optimizationGoal === 'OPTIMIZE_INSTALLS_TARGET_INSTALL_COST'"
            >
              <el-radio-group v-model="formData.biddingStrategyType" size="mini">
                <el-radio-button label="TARGET_CPA">目标每次转化费用</el-radio-button>
                <el-radio-button
                  :disabled="formData.targetUser === 'IN-APP_ACTIONS'"
                  label="MAXIMIZE_CONVERSIONS"
                  >尽可能提高转化次数</el-radio-button
                >
              </el-radio-group>
            </div>
            <div
              class="form-value"
              v-if="
                formData.biddingStrategyType === 'TARGET_CPA' ||
                formData.optimizationGoal === 'OPTIMIZE_IN_APP_CONVERSIONS_TARGET_CONVERSION_COST'
              "
            >
              <el-input style="width: 264px" v-model.trim="formData.cpa" placeholder="请输入出价">
                <template slot="append">USD</template>
              </el-input>
            </div>
          </el-form-item>
        </li>
      </el-form>
    </ul>
  </div>
</template>

<script>
import { getGoogleConversions } from "@/api/promotion-google.js";
import { mapState } from "vuex";
export default {
  components: {},
  data() {
    return {
      formData: {
        optimizationGoal: "OPTIMIZE_INSTALLS_TARGET_INSTALL_COST",
        trackInstallVolumeAction: {
          conversionId: "",
        },
        targetUser: "",
        conversionActions: {
          conversionId: [],
        },
        dailyBudget: "",
        cpa: "",
        biddingStrategyType: "TARGET_CPA",
      },
      rules: {
        trackInstallVolumeAction: [
          {
            validator: (rule, value, callback) => {
              if (
                !this.formData.trackInstallVolumeAction.conversionId &&
                this.formData.optimizationGoal !== "OPTIMIZE_INSTALLS_TARGET_INSTALL_COST"
              ) {
                callback(new Error("请选择跟踪安装次数"));
              } else {
                callback();
              }
            },
            trigger: ["blur", "change"],
          },
        ],
        targetUser: [
          {
            validator: (rule, value, callback) => {
              if (
                this.formData.optimizationGoal === "OPTIMIZE_INSTALLS_TARGET_INSTALL_COST" &&
                !value
              ) {
                callback(new Error("请选择定位用户类型"));
              } else {
                callback();
              }
            },
            trigger: ["blur", "change"],
          },
        ],
        conversionActions: [
          {
            validator: (rule, value, callback) => {
              const { optimizationGoal, conversionActions } = this.formData;
              if (optimizationGoal !== "OPTIMIZE_INSTALLS_TARGET_INSTALL_COST") {
                if (
                  !conversionActions.conversionId ||
                  conversionActions.conversionId?.length == 0
                ) {
                  callback(new Error("请选择转化操作"));
                } else {
                  callback();
                }
              } else {
                callback();
              }
            },
            trigger: ["blur", "change"],
          },
        ],
        dailyBudget: [
          {
            validator: (rule, value, callback) => {
              if (value === "") {
                callback(new Error("请输入日预算"));
              } else if (!/\d+/.test(Number(value)) || Number(value) < 0.01) {
                callback(new Error("请输入不小于0.01的数字"));
              } else {
                callback();
              }
            },
            trigger: ["blur", "change"],
          },
        ],
        cpa: [
          {
            validator: (rule, value, callback) => {
              const { biddingStrategyType, optimizationGoal } = this.formData;
              if (
                biddingStrategyType === "TARGET_CPA" ||
                optimizationGoal === "OPTIMIZE_IN_APP_CONVERSIONS_TARGET_CONVERSION_COST"
              ) {
                if (value === "") {
                  callback(new Error("请输入出价"));
                } else if (!/\d+/.test(Number(value)) || Number(value) < 0.01) {
                  callback(new Error("请输入不小于0.01的数字"));
                } else {
                  callback();
                }
              } else {
                callback();
              }
            },
            trigger: ["blur", "change"],
          },
        ],
        roas: [
          {
            validator: (rule, value, callback) => {
              if (value === "") {
                callback(new Error("请输入tROAS%"));
              } else if (
                !/\d+/.test(Number(value)) ||
                Number(value) < 1 ||
                Number(value) > 100000
              ) {
                callback(new Error("请输入不小于1且不大于100000的数字"));
              } else {
                callback();
              }
            },
            trigger: ["blur", "change"],
          },
        ],
      },
      installNumList: [],
      targetUserList: [
        { label: "所有用户", value: "ALL_USERS" },
        { label: "很可能会执行应用内操作的用户", value: "IN-APP_ACTIONS" },
      ],
      translateOperoteList: [],
    };
  },
  methods: {
    initSelect() {
      const params = {
        advertiserIds: [this.adCount],
        appIds: [this.promoteApp.appId],
        conversionTypes: ["FIRST_OPEN"],
        pageNum: 1,
        pageSize: 999,
      };
      this.formData.trackInstallVolumeAction.conversionId = "";
      this.formData.conversionActions.conversionId = [];
      getGoogleConversions(params).then((res) => {
        this.installNumList = res.data.list;
      });
      getGoogleConversions({
        ...params,
        conversionTypes: ["CUSTOM"],
      }).then((res) => {
        this.translateOperoteList = res.data.list;
      });
    },
    changeOptimizationGoal() {
      this.$set(this.formData.conversionActions, "conversionId", []);
      this.$set(this.formData, "targetUser", "");
    },
    saveInStore() {
      const data = JSON.parse(JSON.stringify(this.formData));
      data.conversionActions = [];
      const { targetUser, optimizationGoal } = this.formData;
      if (
        (targetUser === "IN-APP_ACTIONS" &&
          optimizationGoal === "OPTIMIZE_INSTALLS_TARGET_INSTALL_COST") ||
        optimizationGoal !== "OPTIMIZE_INSTALLS_TARGET_INSTALL_COST"
      ) {
        this.formData.conversionActions.conversionId?.map((item) => {
          data.conversionActions.push({
            conversionId: item,
          });
        });
      }
      this.$store.commit("set_ad_series_google", {
        bid: data,
      });
    },
    checkData() {
      return new Promise((resolve, reject) => {
        this.$refs.bidFormRef.validate((valid) => {
          if (valid) {
            this.saveInStore();
            resolve();
          } else {
            reject();
          }
        });
      });
    },
    fillData(dataItem) {
      // 回显
      this.formData = JSON.parse(JSON.stringify(dataItem));
      if (dataItem.conversionActions.length > 0) {
        this.formData.conversionActions = {
          conversionId: [],
        };
        dataItem.conversionActions.map((item) => {
          this.formData.conversionActions.conversionId.push(item.conversionId);
        });
      }
    },
    changeTargetUser() {
      if (
        this.formData.targetUser === "IN-APP_ACTIONS" &&
        this.formData.optimizationGoal === "OPTIMIZE_INSTALLS_TARGET_INSTALL_COST"
      ) {
        this.formData.biddingStrategyType = "TARGET_CPA";
        this.formData.cpa = "";
      }
    },
  },
  computed: {
    ...mapState({
      promoteApp: (state) => state.PromotionGoogle.draftCampaign.promoteApp,
      adCount: (state) => state.PromotionGoogle.draftCampaign.advertiserId,
      alreadyCampaignId: (state) => state.PromotionGoogle.draftCampaign.campaignId,
      bid: (state) => state.PromotionGoogle.draftCampaign.bid,
    }),
    changeDataObj() {
      return {
        adCount: this.adCount,
        ...this.promoteApp,
      };
    },
  },
  watch: {
    changeDataObj: {
      handler(val) {
        if (val.adCount && val.appId) {
          this.initSelect();
        }
      },
    },
    bid: {
      handler(val) {
        this.fillData(val);
      },
      deep: true,
    },
  },
};
</script>

<style lang="less" scoped>
.bid-wrap {
  padding: 24px;
  margin-top: 16px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  .card-header {
    color: rgba(0, 0, 0, 1);
    font-size: 16px;
    font-weight: bold;
  }
  .modal-form {
    margin-top: 16px;
    padding: 0px;
    list-style: none;
    .form-item {
      display: flex;
      .form-label {
        flex-shrink: 0;
        display: inline-block;
        width: 200px;
        text-align: right;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.65);
        padding-top: 13px;
        &.require::before {
          content: "*";
          display: inline-block;
          color: red;
          margin-right: 4px;
        }
      }
      .form-value {
        width: 100%;
        padding-top: 2px;
        .custom-wrap {
          margin-top: 10px;
        }
        /deep/ .el-radio__input.is-checked .el-radio__inner {
          color: rgba(24, 144, 255, 1);
          border-color: rgba(24, 144, 255, 1);
          background: rgba(24, 144, 255, 1);
        }
        /deep/ .el-radio__input.is-checked + .el-radio__label {
          color: rgba(24, 144, 255, 1);
        }
      }
    }
  }
}
</style>
